import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseArtistReachParams {
  artistId: string;
  date?: Date;
  rangeDays?: number;
}

export const useArtistReach = ({ artistId, date, rangeDays }: UseArtistReachParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  const reachQuery = useTRPCQuery(
    trpcMusicAPI.artists.reach.queryOptions(
      {
        artistId,
        date,
        rangeDays,
        ...shareTokenInput,
      },
      {
        enabled: Boolean(artistId),
      }
    )
  );

  return reachQuery;
};
